import React from 'react';

const Unauthorized = () => (
  <div className="d-flex flex-column align-items-center justify-content-center py-5 text-center">
    <h1 className="display-3 fw-bold">401</h1>
    <p className="lead mb-3">Vous n'avez pas l'autorisation d'accéder à cette page.</p>
    <p className="text-muted">Si vous pensez qu'il s'agit d'une erreur, veuillez contacter un administrateur.</p>
  </div>
);

export default Unauthorized;
